import reduce from 'lodash/reduce';

export default (collection, predicate) => {
  return reduce(collection, (memo, i) => {
    const match = predicate(i);
    if (match) {
      memo.push([]);
    } else {
      memo[memo.length - 1].push(i);
    }
    return memo;
  },[[]]);
};
